import React from "react";

//Page Title at the Top of the website
function PageTitle() {
    const containerStyle = {
        position: 'relative',
        width: '100%',
        height: '170px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    };

    const logoStyle = {
        position: 'absolute',
        left: '0',
        height: '100%',
    };

    // const homeStyle = {
    //     color: '#283618',
    //     fontSize: '40px',
    //     fontWeight: 'bold',
    // };

    return (
        <div style={containerStyle}>
            <img src="/FRCLogo.png" alt="Family Resource Center Logo" style={logoStyle} />

            {/* Remove the MyCommunityFL Logo from Home Screen */}
            {/* < h1 id="backToHome" style={homeStyle}>MyCommunityFL</h1> */}
        </div>
    );
}

export default PageTitle;
